import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { ClientType } from '../../../../../core';

@JsonConverter
export class ClientTypeAdapter implements JsonCustomConvert<ClientType | undefined> {
    serialize(type: ClientType): any | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: any): ClientType | undefined {
        switch (type) {
            case 'NaturalPerson':
                return ClientType.NATURAL_PERSON;
            case 'LegalPerson':
                return ClientType.LEGAL_PERSON;
            case 'Minor':
                return ClientType.MINOR;
            case 'Disabled':
                return ClientType.DISABLED;
            default:
                return undefined;
        }
    }
}
